import loadYoutubeIframeApi from './load-youtube-iframe-api';

let youtubeIframeApi;
const youtubePlayers = new WeakMap();

// One YT.Player per iframe: binding a second one to the same frame breaks
// the first one's events, so the carousel pause and video tracking share it.
export const youtubePlayerFor = iframe => {
  if (!youtubePlayers.has(iframe)) {
    if (!youtubeIframeApi) youtubeIframeApi = loadYoutubeIframeApi();
    const ready = youtubeIframeApi.then(
      YT =>
        new Promise(resolve => {
          const player = new YT.Player(iframe, {
            events: { onReady: () => resolve(player) },
          });
        })
    );
    youtubePlayers.set(iframe, ready);
  }
  return youtubePlayers.get(iframe);
};
